import src from "IMAGE";
export default { src, width: 498, height: 498, blurWidth: 0, blurHeight: 0};
